//* Import API configurations
import { api } from "../../services/apis/configs/axiosConfigs";

//* Import API URI constant
import { API_URI } from "../../constants/consts";

//* Import PaginationData type
import { Pagination } from "../../services/stores/types";

//* Import CSVCollaboratorProcessingError type
import { CSVCollaboratorProcessingError } from "../../utils/csv/csv-validatorCollaborator";

//* Import ImportHistory type
import { ImportHistoryCollaborator, ImportHistoryResponse } from "./types/typesCollaborator";

export const importHistoryCollaboratorAPI = {
  getAll: async function (
    search: string = "",
    page: number = 1,
    token: string,
    perPage: number = 10,
    tableName: string = "collaborators"
  ): Promise<ImportHistoryResponse> {
    const tableNameQuery = tableName
      ? `&table_name=${encodeURIComponent(tableName)}`
      : "";
    const url = `${API_URI}/admin/private/import-histories?${tableNameQuery}`;

    return api
      .request({
        url,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { data } = response.data;

        const pagination: Pagination = data.pagination
          ? {
              currentPage: data.pagination.currentPage,
              totalPages: data.pagination.totalPages,
              itemsPerPage: data.pagination.itemsPerPage,
              totalItems: data.pagination.totalItems,
            }
          : {
              currentPage: 0,
              totalPages: 0,
              itemsPerPage: 0,
              totalItems: 0,
            };

        return {
          import_histories: data.importHistories || [],
          pagination,
        };
      })
      .catch((error) => {
        console.error("Erro ao buscar históricos de importação:", error);
        throw new Error("Falha ao buscar históricos de importação");
      });
  },

  create: async function (
    importData: {
      file_name: string;
      timestamp: string;
      status: "processing" | "finished";
      progress: number;
      total: number;
      table_name: string;
      success: number;
      detailed_errors?: CSVCollaboratorProcessingError[];
      error?: string;
    },
    token: string
  ): Promise<ImportHistoryCollaborator> {
    return api
      .request({
        url: `${API_URI}/admin/private/import-histories`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: importData,
      })
      .then((response) => response.data.data)
      .catch((error) => {
        console.error("Erro ao criar histórico de importação:", error);
        throw new Error("Falha ao criar histórico de importação");
      });
  },
};
